import * as _ from 'lodash';
import { ReportInfo } from '../objects/ReportInfo';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class ReportEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this._url = url;
        this._api = api;
        this._cached = null;
    }

    getReports() {
        return this._api.getResponse(this._url)
            .then(rsp => _.map(rsp.getResult(), x => new ReportInfo(x)));
    }

    generate(id, pars) {
        var parameters = angular.copy(pars);
        return this._api.postDownload(this._url + '/' + id, parameters);
    }
}
